// extracted by mini-css-extract-plugin
export default {"imageContainer":"X6-z","summaryPar":"Y6-z","ratingCategories":"Z6-z","reviewerInfo":"_6-z","reviewTypes":"a7-z","expanded":"b7-z"};